/*
  !!! Flex framework migration notes !!!
  This service builds the flex layout by cutting and gutting css classes grid numbers.
  Still needed or redundant?
*/

import { Injectable } from '@angular/core';

export enum Breakpoints {
  xs = '481',
  sm = '769',
  md = '992',
  lg = '1025',
}

@Injectable({
  providedIn: 'root',
})
export class FlexGridService {
  // NOTE: These need to be kept in sync with values in _variables.scss!!!
  private columns: number = 12;
  constructor() {}

  // Check if the string is a valid breakpoint
  public isBreakpoint(name: string): boolean {
    return name && Breakpoints[name];
  }

  // Given a list of class names like "grid__col-xs-12 grid__col-md-3" figure out how many items with this
  // class name would fit in a row with the current window size.
  public getRowSize(className: string) {
    const size = window.innerWidth;

    // Extract the breakpoint names and indices from a list of classnames
    const brks = className
      ?.split(' ')
      .map((className) => {
        const match = className.match(/grid__col-(\w+)-(\d+)/);
        if (match) {
          const [_, name, idx] = match;
          if (this.isBreakpoint(name)) {
            return { name, idx: parseInt(idx, 10) };
          }
        }
      })
      .filter((brk) => brk);

    // Sort the breakpoint classes by the size of the breakpoints (largest first) and by
    // the index, too, in case there are classes like `grid__col-xs-12 grid__col-xs-11`.
    brks?.sort((a, b) =>
      b.name === a.name
        ? b.idx - a.idx
        : Breakpoints[b.name] - Breakpoints[a.name]
    );

    // Then find the first matching breakpoint for the current window size and convert index to item count
    for (let i = 0; i < brks?.length; i++) {
      const { name, idx } = brks[i];
      if (size > Breakpoints[name]) {
        return Math.floor(this.columns / idx);
      }
    }

    // Return 1 as a default here in case none of the grid classes matched
    return 1;
  }
}
